import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FilterListIcon(props: IconProps) {
    return <Icon {...props} iconKey={"filter_list"}/>
}
